export const READY_STATE_CHANGE = 'readystatechange';
export const READY_STATE_CHANGE_COMPLETE = 'complete';
export const READY_STATE_CHANGE_INTERACTIVE = 'interactive';
export const READY_STATE_LOADING = 'loading';